import React from 'react';
import './EarlyAccessCard.css';
import { useSignupForm } from './useSignupForm';

const EarlyAccessCard = () => {
  const {
    formData,
    loading,
    submitted,
    errorMsg,
    handleChange,
    handleSubmit,
  } = useSignupForm();

  return (
    <div className="early-access-card">
      <h2 className="early-access-title">Get early access to Star Aura</h2>
      <p className="early-access-desc">
        Exclusive celebrity interactions, insights,
        and experiences.
      </p>
      {submitted ? (
        <div className="success-container" style={{ color: '#C5FF00', fontWeight: 600, fontSize: 18 }}>
          Successfully Sent
        </div>
      ) : (
        <form className="early-access-form" onSubmit={handleSubmit}>
          <label htmlFor="fullName" className="early-access-label">Full Name</label>
          <input
            type="text"
            id="fullName"
            name="fullname"
            className="early-access-input"
            value={formData.fullname}
            onChange={handleChange}
            required
          />
          <label htmlFor="email" className="early-access-label">Email Address</label>
          <input
            type="email"
            id="email"
            name="email"
            className="early-access-input"
            value={formData.email}
            onChange={handleChange}
            required
          />
          {errorMsg && (
            <div style={{ color: 'red', marginTop: 4, fontSize: 14 }}>{errorMsg}</div>
          )}
          <button type="submit" className="early-access-btn" disabled={loading}>
            {loading ? 'Submitting...' : 'Request Early Access'}
          </button>
        </form>
      )}
    </div>
  );
};

export default EarlyAccessCard;
